import React, { useEffect, useRef } from "react";
import style from "./ExpertiseList.module.scss";
import { ExpertiseCard } from "../ExpertiseCard/ExpertiseCard";
import gsap from "gsap/all";

const CARD_ANIMATIONS = [
  { rotation: -20, x: 160, y: -100 },
  { rotation: -5, x: 90, y: -170 },
  { rotation: 20, x: -10, y: -80 },
  { rotation: 10, x: -120, y: -120 },
  { rotation: 20, x: -200, y: -100 },
];

const ExpertiseList = ({ cardsServices }: any) => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    let tweens = [];
    let mm = gsap.matchMedia();

    mm.add("(min-width: 1692px)", () => {
      if (!listRef.current) return;
      const cards = listRef.current.querySelectorAll(`.${style.expertiseCard}`);

      const firstCardTop = (cards[0] as HTMLElement)?.offsetTop ?? 0;

      cards.forEach((card, index) => {
        const anim = CARD_ANIMATIONS[index % CARD_ANIMATIONS.length];
        const isFirstRow =
          Math.abs((card as HTMLElement).offsetTop - firstCardTop) < 10;

        tweens.push(
          gsap.fromTo(
            card,
            {
              zIndex: Math.max(cards.length - index, 1),
              y: isFirstRow ? anim.y : 40,
              x: isFirstRow ? anim.x : anim.x * 0.35,
              rotation: anim.rotation,
            },
            {
              y: 0,
              x: 0,
              rotation: 0,
              scrollTrigger: {
                trigger: card,
                start: "center 80%",
                end: "top 30%",
                scrub: true,
              },
            }
          )
        );
      });
    });

    return () => {
      tweens.forEach((tween) => {
        tween?.scrollTrigger?.kill();
        tween?.kill();
      });
      mm.revert();
    };
  }, []);

  return (
    <ul ref={listRef} className={style.cards}>
      {cardsServices &&
        cardsServices.map((expertise: any, index: any) => (
          <li key={index} className={`${style.expertiseCard}`}>
            <ExpertiseCard
              slug={expertise.slug}
              title={expertise.title}
              description={expertise.description}
              tags={expertise.tags}
            />
          </li>
        ))}
    </ul>
  );
};

export default ExpertiseList;
